export const REVIEW_TEMPLATES_PATH = '/reviews/templates';
export const FULL_REVIEW_TEMPLATES_PATH = `${REVIEW_TEMPLATES_PATH}?include=categories,items`;
